export function findTheLastTestReport(product) {
  let foundRecord;

  (product.test_records || []).forEach((record) => {
    if (!foundRecord && record.isArchive) {
      return;
    }

    if (!foundRecord) {
      foundRecord = record;
      return;
    }

    if ((+new Date(foundRecord.testDate)) < (+new Date(record.testDate))) {
      if (record.isArchive) {
        return;
      }
      foundRecord = record;
    }
  });

  return foundRecord;
}